import React, { useState } from 'react'
import InputText from '../input-text/input-text'
import inputProptypes from '../input-proptype'
import { useInitialValueToValidation } from '../custom-hooks'

const InputURL = ({ value, onChange, onBlur, errorMessage, required, ...rest }) => {
  const [currentMessage, setCurrentMessage] = useState(errorMessage)

  const validateUrl = value => {
    setCurrentMessage('')
    if (!value.length && !required) return
    if (!validateUrlValue(value)) setCurrentMessage('URL inválida.')
  }

  const handleOnBlur = value => {
    validateUrl(value)

    if (onBlur) onBlur(value)
  }

  const handleOnChange = async ({ value, id, name }) => {
    if (onChange) await onChange({ value, id, name })

    return value
  }

  let inputProps = {
    onChange: handleOnChange,
    onBlur: handleOnBlur,
    errorMessage: currentMessage,
    required,
    value,
    ...rest,
  }

  useInitialValueToValidation(value, () => {
    if (!value) return

    validateUrl(value)
  })

  return <InputText {...inputProps} />
}

InputURL.propTypes = inputProptypes

const validateUrlValue = url => {
  return /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi.test(
    url
  )
}
export default InputURL
